import { render, staticRenderFns } from "./MovimientosBancariosFormComponent.vue?vue&type=template&id=179e4fcc&"
import script from "./MovimientosBancariosFormComponent.vue?vue&type=script&lang=js&"
export * from "./MovimientosBancariosFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports